import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { useComputedFilters, useFiltersStateStore } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
import { getFilterValueByProperty, updateFilterState } from 'framework-listing-lib/utils/filters';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
export default function useQuickFilters() {
  "use memo";

  return useComputedFilters().quickFilters;
}
export function useQuickFiltersCount() {
  "use memo";

  const quickFilters = useQuickFilters();
  return quickFilters.length;
}
export function useSetQuickFilter() {
  "use memo";

  const $ = _c(3);
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const onSetFilters = useFiltersStateStore(_temp);
  let t0;
  if ($[0] !== onSetFilters || $[1] !== trackCrmTableInteraction) {
    t0 = filterOperator => {
      trackCrmTableInteraction({
        action: "add-quick-filter",
        property: filterOperator.property
      });
      onSetFilters(prev => updateFilterState(prev, {
        quickFilters: [...prev.quickFilters.filter(filter => filter.property !== filterOperator.property), filterOperator]
      }));
    };
    $[0] = onSetFilters;
    $[1] = trackCrmTableInteraction;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function _temp(state) {
  return state.setFilters;
}
export function useRemoveQuickFilter() {
  "use memo";

  const $ = _c(3);
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const onSetFilters = useFiltersStateStore(_temp2);
  let t0;
  if ($[0] !== onSetFilters || $[1] !== trackCrmTableInteraction) {
    t0 = propertyName => {
      trackCrmTableInteraction({
        action: "remove-quick-filter",
        property: propertyName
      });
      onSetFilters(prev => Object.assign({}, prev, {
        quickFilters: [...prev.quickFilters.filter(filter => filter.property !== propertyName)]
      }));
    };
    $[0] = onSetFilters;
    $[1] = trackCrmTableInteraction;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function _temp2(state) {
  return state.setFilters;
}
export function useGetQuickFilterValue() {
  "use memo";

  const $ = _c(2);
  const quickFilters = useQuickFilters();
  let t0;
  if ($[0] !== quickFilters) {
    t0 = (propertyName, t1) => {
      const defaultValue = t1 === undefined ? null : t1;
      return getFilterValueByProperty({
        filterGroups: [{
          filters: quickFilters
        }]
      }, propertyName, defaultValue);
    };
    $[0] = quickFilters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function useSetQuickFilters() {
  "use memo";

  const $ = _c(3);
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const onSetFilters = useFiltersStateStore(_temp3);
  let t0;
  if ($[0] !== onSetFilters || $[1] !== trackCrmTableInteraction) {
    t0 = quickFilters => {
      trackCrmTableInteraction({
        action: "set-quick-filters"
      });
      onSetFilters(prev => updateFilterState(prev, {
        quickFilters
      }));
    };
    $[0] = onSetFilters;
    $[1] = trackCrmTableInteraction;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
function _temp3(state) {
  return state.setFilters;
}
export function useListingLibQuickFilters() {
  "use memo";

  const $ = _c(6);
  const quickFilters = useQuickFilters();
  const getQuickFilterValue = useGetQuickFilterValue();
  const setQuickFilter = useSetQuickFilter();
  const removeQuickFilter = useRemoveQuickFilter();
  const setQuickFilters = useSetQuickFilters();
  let t0;
  if ($[0] !== getQuickFilterValue || $[1] !== quickFilters || $[2] !== removeQuickFilter || $[3] !== setQuickFilter || $[4] !== setQuickFilters) {
    t0 = {
      getQuickFilterValue,
      quickFilters,
      removeQuickFilter,
      setQuickFilter,
      setQuickFilters
    };
    $[0] = getQuickFilterValue;
    $[1] = quickFilters;
    $[2] = removeQuickFilter;
    $[3] = setQuickFilter;
    $[4] = setQuickFilters;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}